export class HVAC {
  brand: string;
  models: Map<string, HVACModel>;
}

export class HVACModel {
  encoder: string;
  maxTemp: number;
  minTemp: number;
  name: string;
  supportFanSpeed: number[];
  supportHSwing: string[];
  supportVSwing: string[];
  supportedOperationModes: string[];

  constructor(encoder: string, maxTemp: number, minTemp: number, supportFanSpeed: number[],
     supportHSwing: string[], supportVSwing: string[], supportedOperationModes: string[] ) {
      this.encoder = encoder;
      this.maxTemp = maxTemp;
      this.minTemp = minTemp;
      this.supportFanSpeed = supportFanSpeed;
      this.supportHSwing = supportHSwing;
      this.supportVSwing = supportVSwing;
      this.supportedOperationModes = supportedOperationModes;
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/devices/devices.utils.ts